import { render, staticRenderFns } from "./userGuideDetail.vue?vue&type=template&id=b39cc652&scoped=true&"
import script from "./userGuideDetail.vue?vue&type=script&lang=js&"
export * from "./userGuideDetail.vue?vue&type=script&lang=js&"
import style0 from "./userGuideDetail.vue?vue&type=style&index=0&id=b39cc652&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39cc652",
  null
  
)

export default component.exports